<a class="nav-tile" [routerLink]="link()">
  <div class="nav-tile__badge">
    <mat-icon aria-hidden="true">{{ icon() }}</mat-icon>
  </div>
  <div class="nav-tile__content">
    <div class="nav-tile__title">{{ titleKey() | translate }}</div>
    <div class="nav-tile__subtitle">{{ subtitleKey() | translate }}</div>
    @if (statValue() !== null && statLabelKey()) {
      <div class="nav-tile__stats">
        <div class="nav-tile__stat">
          <span class="nav-tile__stat-label">{{ statLabelKey()! | translate }}</span>
          <span class="nav-tile__stat-value">{{ statValue() }}</span>
        </div>
      </div>
    }
  </div>
  <mat-icon class="nav-tile__chevron" aria-hidden="true">chevron_right</mat-icon>
</a>
